export default () => ({
  chart: {
    display: 'inline-block',
  },
});
